module.exports = __webpack_public_path__ + "static/media/PMC_LOGO.9c884f9a.svg";